import { useEffect } from 'react'

const MUX_STREAM_BASE = 'https://stream.mux.com/'

/**
 * Mux / DatoCMS file field: streaming + progressive URLs live on the nested
 * `video` object (DatoCmsAssetVideo), not on the file root.
 */
export function getMuxHlsUrl(fileField) {
  const v = fileField?.video
  if (!v) return null
  if (v.streamingUrl) return v.streamingUrl
  if (v.muxPlaybackId) return `${MUX_STREAM_BASE}${v.muxPlaybackId}.m3u8`
  return null
}

export function getMuxProgressiveUrl(fileField) {
  if (!fileField) return null
  const v = fileField.video
  if (v) {
    if (v.mp4UrlHigh) return v.mp4UrlHigh
    if (v.mp4UrlMedium) return v.mp4UrlMedium
    if (v.mp4UrlLow) return v.mp4UrlLow
  }
  return fileField.url || null
}

export function useAttachDatocmsFileVideo(videoRef, fileField) {
  useEffect(() => {
    const el = videoRef.current
    if (!el || !fileField) return undefined

    const hlsUrl = getMuxHlsUrl(fileField)
    const progressive = getMuxProgressiveUrl(fileField)

    el.removeAttribute('src')
    el.load()

    if (!hlsUrl) {
      if (progressive) el.src = progressive
      return undefined
    }

    if (el.canPlayType('application/vnd.apple.mpegurl')) {
      el.src = hlsUrl
      return undefined
    }

    let cancelled = false
    let hls = null

    import('hls.js').then(({ default: Hls }) => {
      if (cancelled || !videoRef.current) return
      const media = videoRef.current
      if (Hls.isSupported()) {
        hls = new Hls()
        hls.loadSource(hlsUrl)
        hls.attachMedia(media)
      } else if (progressive) {
        media.src = progressive
      }
    })

    return () => {
      cancelled = true
      if (hls) {
        hls.destroy()
        hls = null
      }
    }
  }, [
    fileField?.url,
    fileField?.video?.muxPlaybackId,
    fileField?.video?.streamingUrl,
    fileField?.video?.mp4UrlHigh,
    fileField?.video?.mp4UrlMedium,
    fileField?.video?.mp4UrlLow
  ])
}
